/**
 * Object相关方法
 * @type {Object}
 */


function getConstructorName(o) {
    //加o.constructor是因为IE下的window和document
    if (o != null && o.constructor != null) {
        return Object.prototype.toString.call(o).slice(8, -1);
    } else {
        return '';
    }
}

/**
 * 判断一个变量是否String对象
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isString(obj) {
    return typeof obj === 'string' || obj instanceof String;
}

/**
 * 判断一个变量是否Bool值
 * @param  {Boolean}  boolean 目标变量
 * @return {Boolean}
 */
 export function isBoolean(bool) {
    return typeof bool === 'boolean';
}

/**
 * 判断一个变量是否Number对象
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isNumber(obj) {
    return typeof obj === 'number' && isFinite(obj);
}  

/**
 * 判断一个变量是否Array对象
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isArray(obj) {
    return getConstructorName(obj) == 'Array';
}

/**
 * 判断一个变量是否Function对象
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isFunction(obj) {
    return getConstructorName(obj) == 'Function';
}

/**
 * 判断一个变量是否typeof object
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isObject(obj) {
    return obj !== null && typeof obj == 'object';
}

/**
 * 判断对象是否为空
 * @param  {Object}  obj 目标变量
 * @return {Boolean}
 */
export function isEmpty(obj) {
    if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
    } else {
        return false;
    }
}

/**
 * 获取Object对象里的值
 * @param  {Object}  obj 目标对象
 *  @param  {Object}  value 对应的key值
 * @return {Boolean}
 */
 export function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  
  // 是否是 http/https ? url
 export function isHttpURL(url) {
    if (!isString(url)) {
        return false;
    }
    var _a = url.split(':'), protocol = _a[0], path = _a[1];
    if (!path) {
        // 相对路径
        return true;
    }
    return protocol === 'http' || protocol === 'https';
}


/**
 * 将源对象的属性并入到目标对象
 * @param  {Object} des      目标对象
 * @param  {Object} src      源对象，如果是数组，则依次并入
 * @param  {Boolean} override 是否覆盖已有属性
 * @return {Object}          des
 */
export function mix(des, src, override) {
    for (var i in src) {
        //这里要加一个des[i]，是因为要照顾一些不可枚举的属性
        if (override || !(des[i] || (i in des))) {
            des[i] = src[i];
        }
    }
    return des;
}

/**
 * 将Object序列化为key=val键值对字符串，不处理val为数组的情况]
 * @param  {Object} json 需要序列化的对象
 * @return {String}      序列化后的字符串
 */
export function encodeURIJson(obj) {
    var result = [];
    for (var p in obj) {
        if (obj[p] == null) continue;
        result.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
    return result.join('&');
}

/**
 * 将Object序列化为key=val键值对字符串，不处理val为数组的情况]
 * @param  {Object} array 需要序列化的对象
 * @return {String}      序列化后的字符串
 */
export function encodeURIArray(array) {
    var result = [];
    for(var o in array) {
        result.push(encodeURIComponent(Object.keys(array[o]))+'='+encodeURIComponent(Object.values(array[o])));
    }
    return result.join('&');
}
